module.exports = __webpack_public_path__ + "static/media/H4_groot papier.f71c4491.png";